import React, { useState } from 'react';
import '../Style/MailForm.css';
import { init, send } from 'emailjs-com';

const MAIL_SUBMIT_COOLDOWN_MS = 60 * 1000;
const MAIL_LAST_SUBMIT_KEY = 'rin0700_mail_last_submit_at';

function MailForm() {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [website, setWebsite] = useState('');
  const [isSending, setIsSending] = useState(false);

  const sendMail = () => {
    const userID = process.env.REACT_APP_USER_ID;
    const serviceID = process.env.REACT_APP_SERVICE_ID;
    const templateID = process.env.REACT_APP_TEMPLATE_ID;

    if (!userID || !serviceID || !templateID) {
      window.alert('メール送信の設定が見つかりません。');
      return;
    }

    if (website.trim()) {
      return;
    }

    const lastSubmittedAt = Number(
      window.localStorage.getItem(MAIL_LAST_SUBMIT_KEY) || 0
    );
    if (Date.now() - lastSubmittedAt < MAIL_SUBMIT_COOLDOWN_MS) {
      window.alert('少し時間を空けてから再送してください。');
      return;
    }

    init(userID);
    setIsSending(true);

    const templateParams = {
      from_email: email,
      to_name: name,
      subject,
      message,
    };

    send(serviceID, templateID, templateParams)
      .then(() => {
        window.localStorage.setItem(MAIL_LAST_SUBMIT_KEY, String(Date.now()));
        window.alert('お問い合わせを送信しました。');
        setEmail('');
        setName('');
        setSubject('');
        setMessage('');
        setWebsite('');
      })
      .catch((error) => {
        console.error('メール送信エラー:', error);
        window.alert('メール送信に失敗しました。もう一度お試しください。');
      })
      .finally(() => {
        setIsSending(false);
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    sendMail();
  };

  return (
    <main className="mail-page">
      <section className="mail-intro" aria-labelledby="mail-title">
        <p className="mail-eyebrow">CONTACT</p>
        <h2 id="mail-title" className="mail-title">
          お問い合わせ
        </h2>
        <p className="mail-lead">
          制作、開発、メタバース関連のご相談はこちらから送れます。
        </p>
        <div className="mail-contact-list">
          <a href="mailto:komamuraryuichi@gmail.com">
            komamuraryuichi@gmail.com
          </a>
          <a href="https://x.com/rin_0700">@rin_0700</a>
        </div>
      </section>

      <section className="form-container" aria-label="Contact form">
        <form onSubmit={handleSubmit} className="mail-form">
          <div
            aria-hidden="true"
            style={{
              position: 'absolute',
              width: '1px',
              height: '1px',
              padding: 0,
              margin: '-1px',
              overflow: 'hidden',
              clip: 'rect(0, 0, 0, 0)',
              whiteSpace: 'nowrap',
              border: 0,
            }}
          >
            <label htmlFor="website">Website</label>
            <input
              type="text"
              id="website"
              tabIndex="-1"
              autoComplete="off"
              value={website}
              onChange={(e) => setWebsite(e.target.value)}
            />
          </div>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="email" className="form-label">
                Email
              </label>
              <input
                type="email"
                id="email"
                className="form-input"
                placeholder="your@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="name" className="form-label">
                Name
              </label>
              <input
                type="text"
                id="name"
                className="form-input"
                placeholder="お名前 / 会社名"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="subject" className="form-label">
              Subject
            </label>
            <input
              type="text"
              id="subject"
              className="form-input"
              placeholder="相談内容のタイトル"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="message" className="form-label">
              Message
            </label>
            <textarea
              id="message"
              rows="9"
              className="form-input form-textarea"
              placeholder="内容を入力してください"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
            />
          </div>

          <p className="form-note">メール送信には EmailJS を使用しています。</p>
          <button
            type="submit"
            className="form-button"
            disabled={!email || !name || !subject || !message || isSending}
          >
            {isSending ? 'Sending...' : 'Send Message'}
          </button>
        </form>
      </section>
    </main>
  );
}

export default MailForm;
